import { css, cx } from "@emotion/css"

export const filterInputStyles = {
  //filters
  filterSelect: css`
    padding-top: 0;
    padding-bottom: 0;
    margin: 0 2px 0 2px;

    color: var(--white);
    z-index: 1;
    box-shadow: none;
  `,
  filterIcon: css`
    color: var(--white);
    z-index: 1;
  `,
  filterInputLabel: css`
    color: var(--white);
    &.MuiFormLabel-root.Mui-focused {
      color: var(--white);
    }
    position: absolute;
    top: 1.6px;
  `,
  filterInputRoot: css`
    border-radius: 20px;
    width: 146px;
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border: solid 1px var(--other-blue);
      }
    }
    &.Mui-focused {
      .MuiSelect-outlined.MuiSelect-outlined {
        background-color: transparent;
      }
    }
    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border: solid 1px var(--other-blue);
      }
    }
  `,
  filterInput: css`
    background-color: var(--dark-grey-2);
  `,
  filterPaper: css`
    color: var(--white);
    background-color: var(--dark-grey-2);
    box-shadow: none;
    margin-top: 8px;
    li {
      :hover {
        background-color: var(--extra-dark-grey);
      }
    }
  `,
  extrafilterPaper: css`
    margin-top: 4px;
    color: var(--white);
    background-color: var(--dark-grey-2);
    box-shadow: none;
    li {
      :hover {
        background-color: var(--extra-dark-grey);
      }
    }
  `,
}

export const mapMarkerStyles = {
  //markers
  popupLink: css`
    width: fit-content;
    display: block;
    :hover {
      text-decoration: none;
    }
  `,
  popupTitle: css`
    height: 32px;
    color: var(--white);
  `,
  popupBody: css`
    width: 240px;
    height: 80px;
    flex-grow: 0;
    text-align: left;
    color: var(--white);
  `,
  popupDetail: css`
    color: var(--primary-main-light-green);
  `,
  popupNumber: css`
    color: var(--white);
  `,
}
export const stylesWidgetStats = {
  container: css`
    width: 354px;
    height: 156px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: var(--spacing-xl) 0;
    padding: 32px;
    border-radius: 20px;
    background-color: var(--grey-opacity);
  `,
  stats: css`
    width: 150px;
    height: 80px;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 8px 2px 0;
    padding: 0;
  `,
  title: css`
    width: 65px;
    height: 18px;
    text-align: left;
    color: var(--white);
  `,
  value: css`
    width: 99px;
    height: 44px;
    text-align: left;
    color: var(--white);
  `,
  detail: css`
    text-align: left;
    color: var(--white);
  `,
  line4: css`
    width: 1px;
    height: 48px;
    flex-grow: 0;
    background-color: var(--white);
  `,
  text: css`
    text-align: left;
    color: var(--white);
    margin-top: var(--spacing-xxl-2);
    margin-bottom: var(--spacing-xxl-2);
  `,
  topElement: css`
    position: relative;
    z-index: 1;
    width: fit-content;
    height: fit-content;
    white-space: nowrap;
  `,
}

export const standardScrollBar = {
  root: css`
    ::-webkit-scrollbar {
      width: 6px;
      border-radius: 4px;
      background: var(--primary-main-light-green);
    }
    ::-webkit-scrollbar-thumb {
      width: 6px;
      height: 24px;
      border-radius: 10px;
      background: var(--primary-main-light-green);
    }
    ::-webkit-scrollbar-track-piece {
      background: var(--extra-dark-grey);
    }
  `,
}

export const mapViewGridFooter = {
  root: css`
    background-color: var(--secondary-brown);
    font-weight: 700;
  `,
}
export const chartStyles = {
  square: css`
    background-color: #555;
    width: 15px;
    height: 15px;
  `,
  line: css`
    width: 24px;
    position: relative;
    height: 1px;
  `,
  circle: css`
    width: 10px;
    height: 10px;
    border-radius: 5px;
    position: absolute;
    bottom: -4px;
    left: 11px;
  `,
  selectBtn: css`
    .MuiButton-label {
      font-size: 12px;
      font-weight: 400;
      text-transform: capitalize;
    }
  `,
  button: css`
    & span {
      color: var(--other-blue);
    }
  `,
  disabledCheck: css`
    & span {
      color: var(--extra-dark-grey);
    }
  `,
  labelCheckbox: css`
    color: var(--white);
  `,
  drilldownLabel: css`
    font-size: 12px;
    color: var(--white);
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.4px;
  `,
  disabledLabel: css`
    color: var(--extra-dark-grey);
  `,
  shadow: css`
    .MuiBackdrop-root {
      background-color: rgba(77, 119, 78, 70%);
    }
  `,
  title: css`
    color: var(--white);
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0.15px;
    text-align: center;
  `,
  subTitle: css`
    color: var(--white);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    text-align: center;
  `,
  text: css`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.4px;
  `,
}

export const drillDownStyles = {
  drillDownTitle: css`
    ::first-letter {
      text-transform: capitalize;
    }
    color: var(--white);

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.44px;
  `,
  chartTitle: css`
    ::first-letter {
      text-transform: capitalize;
    }
    color: var(--white);
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.4px;
  `,

  item: css`
    color: var(--white);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  formControl: css`
    &.MuiFormControlLabel-root {
      flex-direction: row-reverse;
      cursor: auto;
      margin-right: 0;
    }
    & svg {
      width: 24px;
    }
  `,
  truncateText: css`
    width: 155px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
}
export const tableStyles = {
  cell: css`
    color: var(--white);
    text-decoration: none;
    text-overflow: ellipsis;
  `,
  border: css`
    border-bottom: solid 1px var(--extra-dark-grey);
    .MuiButton-text {
      padding-bottom: 1px;
    }
  `,
  tabSelected: css`
    color: var(--white);
    border-bottom: solid 1px var(--white);
    text-transform: none;
  `,
  tabNotSelected: css`
    color: var(--dark-grey);
    text-transform: none;
  `,
  dotIconContainer: css`
    position: relative;
    display: inline-block;
    width: 12px;
    height: 12px;
    margin: 0px 8px 0 0;
    border: 1px solid var(--extra-dark-grey2);
    border-radius: 10px;
    background-color: var(--extra-dark-grey2);
  `,
  dotIcon: css`
    position: absolute;
    width: 6px;
    height: 6px;
    margin: 0 auto;
    top: calc(50% - 3px);
    left: calc(50% - 3px);
    border: 1px solid var(--extra-dark-grey2);
    border-radius: 10px;
  `,
  truncateText: css`
    width: 85px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
}
export const autoCompleteStyles = {
  root: css`
    background-color: var(--dark-grey-2);
    z-index: 1;
    color: var(--white);
    min-width: 146px;
    border-radius: 20px;
    height: 32px;
    padding: 0px !important;

    .MuiAutocomplete-inputRoot .MuiAutocomplete-input {
      min-width: 85px;
    }
    .MuiAutocomplete-input {
      flex-grow: unset;
    }
    .MuiFormLabel-root {
      color: var(--white);
      outline: none;
    }
  `,
  paper: cx(
    filterInputStyles.filterPaper,
    css`
      background: var(--dark-grey-2);
      color: var(--white);
      font-size: 14px;

      *::-webkit-scrollbar {
        width: 6px;
        border-radius: 4px;
        background: var(--primary-main-light-green);
      }
      *::-webkit-scrollbar-thumb {
        width: 6px;
        height: 24px;
        border-radius: 4px;
        background: var(--primary-main-light-green);
      }
      *::-webkit-scrollbar-track-piece {
        background: var(--extra-dark-grey);
      }
    `,
  ),
  loading: css`
    color: var(--white);
  `,
  noOptions: css`
    color: var(--white);
  `,
}

export const inputCustomStyles = {
  blue: css`
    background: var(--other-blue);
  `,
  grey: css`
    background-color: var(--dark-grey-2);
  `,
  disabled: css`
    .MuiFormLabel-root {
      color: #aeb5bc;
      outline: none;
    }
  `,
  inputRoot: css`
    color: var(--white);
    border-radius: 20px;

    overflow: hidden;
    height: 34px;
    margin-top: -2px !important;
    padding: 0px 10px 0px 10px !important;
    border: none;

    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border: solid 1px var(--other-blue);
      }
    }
    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border: solid 1px var(--other-blue);
      }
    }
  `,
  focused: css`
    .MuiFormLabel-root {
      color: var(--white);
      outline: none;
    }
  `,
}

export const brandsColors = {
  UM: "var(--other-red)",
  Initiative: "var(--other-extra-light-blue)",
  Matterkind: "var(--other-orange)",
  Orion: "var(--other-blue)",
  Reprise: "var(--other-purple)",
  Rapport: "var(--other-magenta)",
  "SBU Others": "var(--other-glow-green)",
  "All Others": "var(--primary-main-light-green)",
}
